var config: any = {
	serviceUrl: `${window.location.protocol}//${window.location.hostname}/PayrazrApiWeb`,
	hpfServiceUrl: `${window.location.protocol}//${window.location.hostname}/HostedPaymentFormApi`,
	portalUrl: `${window.location.protocol}//${window.location.hostname}/NewPortalWeb`
};

export default config;
